import './AdhesionAd.scss';
import React, {
  CSSProperties,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { AdConfig } from '@pages/Root/services/api/ads/ad-model-definitions.ts';
import { defineAdSlot } from '../../utils/ads-util.ts';
import { IAdMapData } from '@pages/Root/pages/HomeRoot/interfaces.ts';
import { isDntEnabled } from '@utils/dnt.ts';
import { useAds } from '@moment/context/AdsContext.tsx';

export interface AdhesionAdProps {
  adUnitId: string;
  style?: CSSProperties;
}

export const AdhesionAd = (props: AdhesionAdProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isDoNotSell] = React.useState<boolean>(isDntEnabled());
  const { isReady, adConfigData } = useAds();

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const getAdSize = useCallback((): IAdMapData => {
    let screenSize = 320;
    if (window.googletag) {
      const width = window.innerWidth;

      if (width >= 1200) {
        screenSize = 1193;
      } else if (width >= 992) {
        screenSize = 970;
      } else if (width >= 768) {
        screenSize = 684;
      }
    }
    return {
      screenSize: [screenSize, 0],
      adSizeList: [[320, 50]],
    };
  }, []);

  const renderAd = useCallback(
    (adConfig: AdConfig) => {
      if (adConfig?.adhesionAd && window.googletag && !isDoNotSell) {
        const responsiveSize: IAdMapData = getAdSize();
        console.log(
          `defining ad slot ${props.adUnitId} as ${adConfig.adhesionAd.unitPath}`
        );
        defineAdSlot(
          adConfig.adhesionAd,
          props.adUnitId,
          [responsiveSize.adSizeList],
          [responsiveSize]
        );
      }
    },
    [props.adUnitId, window.googetag]
  );

  useEffect(() => {
    if (isReady && adConfigData) {
      const adConfig: AdConfig = new AdConfig(adConfigData);
      renderAd(adConfig);
    }
  }, [renderAd, isReady, adConfigData]);

  return useMemo(
    () => (
      <div className="adhesion-ad--block" style={props.style || {}}>
        <button onClick={toggleVisibility}>
          <span id="mp-banner-arrow-icon">{isVisible ? '▼' : '▲'}</span>
        </button>
        <div
          key="ad-adhesion"
          className={`adhesion__ad ${isVisible ? '' : 'adhesion__ad--hide'}`}
          id={`ad_unit_${props.adUnitId}`}
        ></div>
      </div>
    ),
    [isVisible, props.style]
  );
};
